import React, { Component } from 'react'
import { Footer } from '../../section';
import NavigationDots from '../NavigationDots/NavigationDots';
import SocialMedia from '../SocialMedia/SocialMedia';

const SectionWrapper = ( Component: any, idName: string, classNames?: string, showCopyright?: boolean ) => function HOC() {
  return (
    <div id={idName} className={`app__container ${classNames}`}>
      <SocialMedia />

      {showCopyright ?
      <div className="app__wrapper_copyright app__flex">
        <Component />
        <Footer />
      </div>
      : <div className="app__wrapper app__flex">
        <Component />
      </div>
}

      <NavigationDots active={idName} />
    </div>
  )
}

export default SectionWrapper